import { useMe } from "@/api/queries/auth";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { ROLES } from "@/constants/users";
import { Outlet } from "react-router-dom";

import { AppSidebar } from "./sidebar";

export const DashboardLayout = () => {
  const { data: me } = useMe();

  const isAdmin = me?.data?.role === ROLES.ADMIN;

  return (
    <SidebarProvider>
      <AppSidebar />

      <SidebarInset className="min-w-0">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="dark:text-white" />
          <Separator orientation="vertical" className="h-4" />

          <div>
            {isAdmin ? (
              <>
                <h1 className="text-lg font-semibold dark:text-white">Sing AG Administration</h1>
                <p className="text-sm text-muted-foreground dark:text-white">
                  Manage users, roles, and system activity
                </p>
              </>
            ) : (
              <h1 className="text-lg font-semibold dark:text-white">Agent Console</h1>
            )}
          </div>
        </header>

        <main className="flex-1 p-6 min-w-0">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};
